import React from 'react';
import { useIntl } from 'react-intl';
import core, { App } from '@gin-betting/core';

import SmartLink from '../SmartLink/SmartLink';
import messages from './messages';

import './NoResults.scss';

const { getFiltersFromLocation } = core.utils;

interface Props {
    type?: App.PageType;
    defaultMessage?: string;
    listType?: App.PageType;

    linkHandler?: () => void;
    error?: any;
}

const NoResults: React.FC<Props> = ({
    type,
    error,
    defaultMessage,
    linkHandler,
    listType,
}) => {
    const { formatMessage } = useIntl();
    const defaultMsg =
        defaultMessage || formatMessage(messages.noResultsMessageDefault);
    const defaultSearchMessage = formatMessage(messages.noResultsMessageSearch);
    const inputMoreMessage = formatMessage(messages.noResultsMessageMore);
    const noPageMessage = formatMessage(messages.noResultsMessagePage);

    const getMessages = (): { message: string; linkMessage?: string } => {
        const { search, page } = getFiltersFromLocation();
        const showSecond = search && search.length < 2;

        if (type === App.PageType.LIST && showSecond)
            return { message: inputMoreMessage };

        if (search) return { message: defaultSearchMessage };

        if (error) {
            return {
                message: defaultMsg,
                linkMessage: formatMessage(messages.noResultsMessageTryAgain),
            };
        }

        if (page && +page > 1) {
            return { message: noPageMessage, linkMessage: 'All Games' };
        }

        return { message: defaultMsg };
    };

    const renderLinkedMessage = (linkMessage: string) => {
        const linkTo = listType || '/';

        return linkHandler ? (
            <div styleName="linked-message" onClick={linkHandler}>
                {linkMessage}
            </div>
        ) : (
            <SmartLink styleName="linked-message" to={linkTo}>
                {linkMessage}
            </SmartLink>
        );
    };

    const { message, linkMessage } = getMessages();

    return (
        <div styleName="container" className="__app-NoResults-container">
            <div styleName="message" className="__app-NoResults-messages">
                {message}
            </div>
            {linkMessage && renderLinkedMessage(linkMessage)}
        </div>
    );
};

export default NoResults;
